import '../../Style/home/content.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CusIconLabel from "../../Components/custom-icon-label/Cus_Icon_Label.js";
import { t } from "i18next";
function ContentSection(){
    return (            
        <section className="content-home">
            <div className="home-content-wrapper">
                <div className="content-form">
                    <label className="content-label-title-form home-content-product">{t("product")}</label>
                    <div className="title-content-wrap">
                        <h2 className="title-font-content home-title-product">Phú Bảo An Gia 2.0</h2>
                    </div>
                    <p className="home-desc-title-product">Bảo vệ toàn diện trước 10 bệnh hiểm nghèo thường gặp</p>
                    <br/>
                    <span>
                        <CusIconLabel Icon={CheckCircleIcon} text={"Giảm gánh nặng tài chính trước các rủi ro bệnh hiểm nghèo."} />
                        <CusIconLabel Icon={CheckCircleIcon} text={"Gói bảo hiểm đa dạng với mức chi phí hợp lý"} />
                        <CusIconLabel Icon={CheckCircleIcon} text={"Tham gia trực tuyến đơn giản, không cần khám sức khỏe."} />
                    </span>
                </div>
                {/* <div className="content-img">
                    <img className="img-style" src="/Assets/Images/logo_product.png" alt="Thông tin sản phẩm" />
                </div> */}
            </div>
        </section>    
    );
}
export default ContentSection;